import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { TextInput } from "@toddle-edu/ds-web";
import classes from "./MarksComponent.scss";
import {
  checkScoreValueValidity,
  updateEvaluateScoreInCache,
  getTotalScore,
} from "Worksheet/modules/WorksheetUtils";
import classNames from "classnames";
import {
  MODE_TEACHER_VIEW,
  MODE_TEACHER_EVALUATE,
  MODE_STUDENT_EVALUATE,
  QUESTION_UID_MULTI_PART,
} from "Worksheet/modules/WorksheetConstants";

const MarksComponent = props => {
  const {
    maxMarks,
    score,
    isQuestion,
    questionSubmissionId,
    updateEvaluateScore,
    mode,
    questionTypeUid,
    isEvaluationApplicable,
    studentNotSubmitted,
    updateScoreElementRating,
    totalMarks,
    parentSubmissionId,
    isTeacherEvaluationHeader,
  } = props;

  const updateScore = value => {
    if (!checkScoreValueValidity({ maxMarks, newScoreValue: value })) return;
    const newScoreValue = value == "" ? null : value;

    const userFilter = _.includes(
      [MODE_TEACHER_EVALUATE, MODE_TEACHER_VIEW, MODE_STUDENT_EVALUATE],
      mode
    )
      ? "ALL"
      : "SELF";

    updateEvaluateScoreInCache({
      submissionId: questionSubmissionId,
      value: newScoreValue,
      userFilter,
    });
    // get updated total score
    const totalScore = getTotalScore({
      submissionId: parentSubmissionId,
      mode,
    });
    updateScoreElementRating({ maxScore: totalMarks, scoreValue: totalScore });

    updateEvaluateScore({
      scoreVal: newScoreValue,
      userFilter,
    });
  };

  const onTextInputChange = e => {
    const value = _.get(e, "target.value");
    updateScore(value);
  };

  // optimistic update on blur
  const onBlur = () => {
    if (_.includes(score, ".")) {
      updateScore(_.toString(parseFloat(score)));
    }
  };

  // It selects the text inside the input field so that if the user starts typing,
  // the previous text gets replaced by the new input.
  const onFocus = event => {
    event.target.select();
  };

  const isDisabled =
    !isQuestion ||
    !isEvaluationApplicable ||
    _.isEqual(mode, MODE_TEACHER_VIEW) ||
    _.isEqual(questionTypeUid, QUESTION_UID_MULTI_PART) ||
    studentNotSubmitted;

  const marksContainerClasses = classNames(classes.marksContainer, {
    [classes.teacherEvaluationHeader]: isTeacherEvaluationHeader,
  });

  return (
    <div className={marksContainerClasses}>
      <div className={classes.input}>
        <TextInput
          size="small"
          value={score || score == 0 ? score : ""}
          onChange={onTextInputChange}
          disabled={isDisabled}
          onBlur={onBlur}
          onFocus={onFocus}
          testId={`worksheet-marksComponent-marks-${questionTypeUid}`}
        />
      </div>
      <div className={classes.text}>
        <span className="text-body-1">/{maxMarks}</span>
      </div>
    </div>
  );
};

MarksComponent.propTypes = {
  isQuestion: PropTypes.bool,
  maxMarks: PropTypes.number,
  score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateEvaluateScore: PropTypes.func,
  questionSubmissionId: PropTypes.string,
  isEvaluationApplicable: PropTypes.bool,
  studentNotSubmitted: PropTypes.bool,
  updateScoreElementRating: PropTypes.func,
  totalMarks: PropTypes.number,
  parentSubmissionId: PropTypes.string,
  isTeacherEvaluationHeader: PropTypes.bool,
};

MarksComponent.defaultProps = {
  isQuestion: false,
  maxMarks: 0,
  isEvaluationApplicable: true,
  studentNotSubmitted: false,
  totalMarks: 0,
  parentSubmissionId: null,
  updateScoreElementRating: _.noop,
  isTeacherEvaluationHeader: false,
};

const mapStateToProps = state => {
  const parentSubmissionId = _.get(state, "worksheet.parentSubmissionId", null);

  return {
    parentSubmissionId,
  };
};

export default connect(mapStateToProps, null)(MarksComponent);
